import React from 'react';
import { useSelector } from 'react-redux';
import { useState } from "react";
import useSnackbar from '../../../hooks/useSnackbar';
import { getTransactionCustomerRefundApplyCredits, getTransactionCustomerDeposit } from "../../../api/transaction-type";
import { customerRefundApplyCreditsTable, customerRefundApplyDepositsTable} from '../../../config/grid-column-defs';
import AgGridPaginatedTable from '../../../components/AgGridPaginatedTable';

import { slugMap } from '../../../config/slug-config';
import { useParams } from 'react-router-dom';
import { Box, Tabs, Tab, CircularProgress } from '@mui/material';
import TabPanel from "../../../components/TabPanel";

export default function PaymentApply() {

  const snackbar = useSnackbar();
  const { data: user } = useSelector(state => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const pageDetail = slugMap[params.slug];

  const [subTabIndex, setSubTabIndex] = useState(0);
  const [creditsAppliedSum, setCreditsAppliedSum] = useState("0.00");
  const [depositsAppliedSum, setDepositsAppliedSum] = useState("");

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {  
  //     setTableRefreshCount(prev => prev + 1);
  // }

  async function getTransactionCustomerRefundApplyCreditsData(limit, offset) {
    try {
      const { data } = await getTransactionCustomerRefundApplyCredits(user.token, { id: params.docNo, 
        limit, offset });
      setCreditsAppliedSum(data.data.sum);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true }
    } finally {
      // setLoading(false);
    }
  }

  async function getTransactionCustomerRefundApplyDepositsData(limit, offset) {
    try {
      const { data } = await getTransactionCustomerDeposit(user.token, { id: params.docNo, 
        limit, offset });
      setDepositsAppliedSum(data.data.sum);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true }
    } finally {
      // setLoading(false);
    }
  }

  return (
    <>
    <Box className="sub-tab" sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: '#fff' }}>
      <Tabs
        value={subTabIndex}
        // onChange={handleChange}
        onChange={(e, snv) => {
          setSubTabIndex(snv);
        }}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
        className="tabs-sub-bkg"
      >
        <Tab label={`Credits ${creditsAppliedSum}`} />
        <Tab label={`Deposits ${depositsAppliedSum}`} />
      </Tabs>

      {/* Credits */}
      <TabPanel value={subTabIndex} index={0}>
        <AgGridPaginatedTable getTableRows={getTransactionCustomerRefundApplyCreditsData}
          columns={customerRefundApplyCreditsTable} perPage={5} refreshCounter={0}
        />
      </TabPanel>
      {/* Credits */}
      
      {/* Deposits*/}
      <TabPanel value={subTabIndex} index={1}>
        <AgGridPaginatedTable getTableRows={getTransactionCustomerRefundApplyDepositsData}
          columns={customerRefundApplyDepositsTable} perPage={5} refreshCounter={0}
        />
      </TabPanel>
      {/* Deposits */}

    </Box>
    </>
  )
}



